<template>
    <div id="importScanningFile">
        <a-modal
                :title="disNames.groupWave"
                :visible="groupWaveVis"
                @cancel="() => (cancel())"
        >
            <template slot="footer">
                <a-button :disabled="isDisabled" key="submit" type="primary"  @click="createWave">{{ disNames.createWave }}</a-button>
            </template>
            <a-form :form="form" style="height: 60px;">
                <a-row type="flex" class="buttonLine">
                    <a-col :span="2">
                    </a-col>
                    <a-col :span="7">
                        <a-form-item :label="disNames.single">
                            <a-checkbox v-model="single" size="large"></a-checkbox>
                        </a-form-item>
                    </a-col>
                    <a-col :span="7">
                        <a-form-item :label="disNames.multiplePiece">
                            <a-checkbox v-model="multiplePiece" size="large"></a-checkbox>
                        </a-form-item>
                    </a-col>
                    <a-col :span="7">
                        <a-form-item :label="disNames.multipleLine">
                            <a-checkbox v-model="multipleLine" size="large"></a-checkbox>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>
        </a-modal>

    </div>
</template>

<script>
    import ajax from "../../../api/ajax";
    import api from "../../../api/url";

    export default{
        data(){
            return{
                form:this.$form.createForm(this),
                groupWaveVis: false,
                single: true,
                multipleLine: true,
                multiplePiece: true,
                isDisabled: false,
                disNames:{},
                params:null,
            }
        },
        created() {
            this.init();
        },
        methods:{
            show(params) {
                this.groupWaveVis = true;
                this.params = params;
            },
            init() {
                this.groupWaveConfig();
            },
            cancel() {
                this.groupWaveVis = false;
                this.single = true;
                this.multipleLine = true;
                this.multiplePiece = true;
            },
            createWave(){
                this.isDisabled = true;
                let requestArgs ={
                    "single":this.single,
                    "multipleLine":this.multipleLine,
                    "multiplePiece" : this.multiplePiece,
                    "genericParams": this.params
                }
                ajax.post(api.GROUPWAVE, requestArgs).then(res => {
                    this.isDisabled = false;
                    this.single = true;
                    this.multipleLine = true;
                    this.multiplePiece = true;
                    if (res.code == 200) {
                        this.groupWaveVis = false;
                        let waveUids = res.data;
                        if (waveUids != null && waveUids.length > 100 ){
                            this.$message.success(res.msg+";"+" Insert "+waveUids.length+" rows of data");
                        }else {
                            this.$message.success(res.msg);
                        }

                        let waveUidsStr = "";
                        if (waveUids != null  && waveUids.length <= 100 ){
                            for (let i in  waveUids){
                                if (waveUidsStr.length > 0){
                                    waveUidsStr += ",";
                                }
                                waveUidsStr += waveUids[i];
                            }
                        }
                        this.$emit("routerWavePage", waveUidsStr);
                    }else{
                        this.$customMessage.error(res.msg);
                    }
                });
            },
            //语言 切换
            groupWaveConfig() {
                ajax.get(api.GETGROUPWAVEDISNAME, null).then(res => {
                    if (res.code == 200) {
                        this.disNames = res.data;
                    }
                });
            },
        }
    }
</script>

<style>
</style>